import type { FormSubmitter, LeadPayload, SubmitResult } from '@/lib/submitter/types';

const SIMULATED_LATENCY_MS = 300;

function generateTraceId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `trace-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

/**
 * Dev-адаптер. Логирует payload в `console.info('[lead]', payload)` после
 * 300 ms задержки (имитация сети). Всегда возвращает `ok: true`.
 */
export function createConsoleSubmitter(): FormSubmitter {
  return {
    id: 'console',
    submit(payload: LeadPayload): Promise<SubmitResult> {
      return new Promise((resolve) => {
        setTimeout(() => {
          console.info('[lead]', payload);
          resolve({ ok: true, traceId: generateTraceId() });
        }, SIMULATED_LATENCY_MS);
      });
    },
  };
}
